// Theme-Manager: Light / Dark / System mit localStorage-Persistenz.

export type Theme = "light" | "dark" | "system";

const STORAGE_KEY = "wbr.theme";

export function getStoredTheme(): Theme {
  if (typeof window === "undefined") return "system";
  const v = localStorage.getItem(STORAGE_KEY);
  if (v === "light" || v === "dark" || v === "system") return v;
  return "system";
}

export function setStoredTheme(theme: Theme): void {
  localStorage.setItem(STORAGE_KEY, theme);
  applyTheme(theme);
}

export function applyTheme(theme: Theme): void {
  const root = document.documentElement;
  const isDark = theme === "dark" ||
    (theme === "system" && window.matchMedia?.("(prefers-color-scheme: dark)").matches);
  root.classList.toggle("dark", isDark);
}

export function watchSystemTheme(callback: () => void): () => void {
  const mq = window.matchMedia?.("(prefers-color-scheme: dark)");
  if (!mq) return () => {};
  const handler = (): void => {
    if (getStoredTheme() === "system") callback();
  };
  mq.addEventListener("change", handler);
  return () => mq.removeEventListener("change", handler);
}
